import React from 'react';
import styles from './post-body.module.css';

interface IProps {
	content: string | TrustedHTML;
}

export default function PostBody({ content }: IProps) {
	return (
		<div className="mx-auto">
			<div
				className={styles.content}
				dangerouslySetInnerHTML={{ __html: content }}
			/>
		</div>
	);
}
